import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "@/mock/demo/rest.resolver";
import { DATA_SOURCES_MAP } from "../data-relations/data-sources.map";
import {
  SourceBrief,
  PasswordAcquisitionDescriptor,
  DataSourceType,
  SourceAcquisitionDescriptor,
  SourceConnection,
  ScanSession,
  ScanSessionStatus,
} from "../model";
import { UseSimpleCarousel } from "@/common/composition/use-carousel";

const msft_365 = {
  id: "msft_365",
  name: "Microsoft Office 365",
  type: "AtRest",
  multiConnectionAllowed: true,
  reentrantSessionAllowed: false,
  startParams: ["rootUrl"],
  statistics: {
    connectionCount: 15,
    liveRunningScansCount: 0,
    lastScanAt: "9999-12-31T23:59:59.9999999Z",
    wasScanned: true,
  },
};

const sort_bol = (d: boolean) => (d ? 1 : 0);
// @ts-ignore
const calls: Record<RestCallsKey, MockRestCall> = {
  "data-sources.load-all-sources-status": {
    delay: 2000,
    payload: async () => {
      const lastScanAt = new Date().toISOString();
      const sources = Object.entries(DATA_SOURCES_MAP).map(
        ([service_id, { desc, icon, name, security_posture_group }]) => {
          if (service_id !== "msft_365") {
            return {
              id: service_id,
              multiConnectionAllowed: true,
              name,
              reentrantSessionAllowed: true,
              managedExternally: false,
              startParams: ["some key", "another key"],
              runtime: {
                enabled: true,
                desc,
                icon,
              },
              type: security_posture_group[0],
              statistics: {
                wasScanned: true,
                connectionCount: 3,
                lastScanAt,
                liveRunningScansCount: 1,
              },
            } as SourceBrief;
          } else {
            return {
              ...msft_365,
              type: "AtRest",
              runtime: {
                enabled: true,
                desc,
                icon,
              },
            };
          }
        }
      );
      /*   .sort(
          (a, b) => sort_bol(b.runtime.enabled) - sort_bol(a.runtime.enabled)
        ); */
      console.log("all sources:", sources);
      return sources;
    },
  },
  "data-source.get-source-acquisition-descriptor": {
    delay: 200,
    payload: async (
      source_id: DataSourceType
    ): Promise<SourceAcquisitionDescriptor> => {
      if (source_id === "motion_365") {
        return {
          type: "Consent",
          appId: "motion_365",
          endpointUrl:
            "http://localhost:8080/data-sources-management?code=bubu",
          stateParam: "state",
          consentParam: "code",
        };
      } else {
        return {
          type: "Password",
          appId: source_id,
          fields: {
            root: {
              hint: "/root/..",
              name: "Root folder",
              title: "setting root folder",
            },
            password: {
              hint: "******",
              name: "Password",
              title: "set password",
            },
          },
        } as PasswordAcquisitionDescriptor;
      }
    },
  },
  "data-sources.setup-source-via-token": {
    delay: 1000,
    payload: async (payload: any) => {
      console.log("data-sources.setup-source-via-token:", payload);
      return true;
    },
  },
  "data-sources.setup-source-via-keys": {
    delay: 1000,
    payload: async (payload: any) => {
      console.log("data-sources.setup-source-via-keys:", payload);
      return true;
    },
  },
  "data-sources.get-source-connections": {
    delay: 200,
    payload: async (source_id: string): Promise<SourceConnection[]> => {
      const time = new Date().toISOString();
      return Array(4)
        .fill("")
        .map((_, index) => {
          return {
            id: "_id" + index,
            name: "connection name " + index,
            creationTime: time,
            updateTime: time,
          };
        });
    },
  },
  "data-source.get-source-sessions": {
    delay: 200,
    payload: async (source_id: DataSourceType): Promise<ScanSession[]> => {
      const time = new Date().toISOString();
      const status = UseSimpleCarousel<ScanSessionStatus>([
        "Cancelled",
        "Closed",
        "Opened",
      ]);
      return Array(50)
        .fill("")
        .map((_, index) => {
          status.next();
          return {
            id: "session_id_" + index,
            connectionId: "connection_" + index,
            connectionName: "some complicated connection name " + index,
            startTime: time,
            name: "mock session name " + index,
            isConnectionAlive: true,
            endTime: time,
            reason:
              status.current_item.value === "Cancelled"
                ? "canceled because i wanted to..."
                : "closed do to data limit",
            service: source_id,
            startParams: { siteUrl: "somesite.com/to/the/root" },
            status: status.current_item.value,
          };
        });
    },
  },
  "data-sources.remove-connection": {
    delay: 400,
    payload: async () => {
      return true;
    },
  },
  "data-sources.stop-scan": {
    delay: 400,
    payload: async () => {
      return true;
    },
  },
  "data-sources.start-scan": {
    delay: 400,
    payload: async () => {
      return true;
    },
  },
  //
};

// @ts-ignore
window.inject_mock_api(calls);
